import { useState } from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";

export function CookieBanner() {
  const { t } = useApp();
  const [choice, setChoice] = useState(() => localStorage.getItem("zeta_cookie"));
  if (choice) return null;

  const decide = (v) => {
    localStorage.setItem("zeta_cookie", v);
    setChoice(v);
  };

  return (
    <div className="fixed bottom-4 inset-x-4 md:left-auto md:right-6 md:max-w-md z-40 rounded-xl glass-card shadow-xl p-5" data-testid="cookie-banner">
      <p className="text-sm text-[#F2F5F7] leading-relaxed">
        {t({
          tr: "Sitemiz yalnızca zorunlu çerezler kullanır. Onayınız olmadan hiçbir takip çerezi çalıştırılmaz.",
          en: "Our site uses only essential cookies. No tracking cookies run without your consent.",
        })}{" "}
        <Link to="/cerez" className="underline text-[var(--accent)]">
          {t({ tr: "Çerez Politikası", en: "Cookie Policy" })}
        </Link>
      </p>
      <div className="flex gap-3 mt-4">
        <button onClick={() => decide("accepted")} data-testid="cookie-accept" className="flex-1 rounded-[8px] bg-[#0A0E14] text-white text-sm font-semibold py-2.5 hover:opacity-90 transition-opacity">
          {t({ tr: "Kabul et", en: "Accept" })}
        </button>
        <button onClick={() => decide("rejected")} data-testid="cookie-reject" className="flex-1 rounded-[8px] border border-white/20 text-sm font-semibold py-2.5 hover:border-white/40 transition-colors">
          {t({ tr: "Reddet", en: "Reject" })}
        </button>
      </div>
    </div>
  );
}
